"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var libphonenumber_js_1 = require("libphonenumber-js");
function phoneNumberValidationRule(_a, path, context) {
    var index = _a.index, messages = _a.messages, schema = _a.schema;
    if (!context.customs[index]) {
        context.customs[index] = { schema: __assign(__assign({}, schema), { parsePhoneNumberFromString: libphonenumber_js_1.parsePhoneNumberFromString }) };
    }
    else {
        context.customs[index].schema.parsePhoneNumberFromString = libphonenumber_js_1.parsePhoneNumberFromString;
    }
    return {
        source: "\n    const parsePhoneNumberFromString = context.customs[" + index + "].schema.parsePhoneNumberFromString;\n    const pn = parsePhoneNumberFromString(value || '');\n\n    if (!value && !!" + schema.optional + ") {\n      return value;\n    }\n\n    if (!pn || !pn.isValid()) {\n      " + this.makeError({
            actual: 'value',
            messages: messages,
            type: 'phoneNumber',
        }) + ";\n    }\n\n    return value;\n  ",
    };
}
exports.default = phoneNumberValidationRule;
//# sourceMappingURL=phoneNumberValidationRule.js.map